import React from "react";

const Enlarge = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1634_743" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1634_743)">
        <path
          d="M2.5 17.5V10.8333H4.16667V14.6667L14.6667 4.16667H10.8333V2.5H17.5V9.16667H15.8333V5.33333L5.33333 15.8333H9.16667V17.5H2.5Z"
          fill="#03579E"
        />
      </g>
    </svg>
  );
};

export default Enlarge;
